module.exports = __webpack_public_path__ + "3f2b822a6e8e8109999b95b3ea8d45bb.png";